import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { get } from 'lodash';

import { PdfSettingsExtraPaddingModel } from '../../models';
import { PdfSettingsSizeEnum } from '../../enums';

@Component({
  selector: 'rnpl-pdf-spacer-form',
  templateUrl: './pdf-spacer-form.component.html',
  // styleUrls: ['./pdf-spacer-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfSpacerFormComponent implements OnChanges, OnDestroy {

  @Input() padding: PdfSettingsExtraPaddingModel;

  @Output() paddingUpdated: EventEmitter<null> = new EventEmitter<null>();

  public form: FormGroup =  new FormGroup({
    top: new FormGroup({
      // enabled: new FormControl(),
      size: new FormControl(),
      height: new FormControl(null, {updateOn: 'blur'})
    }),
    bottom: new FormGroup({
      // enabled: new FormControl(),
      size: new FormControl(),
      height: new FormControl(null, {updateOn: 'blur'})
    }),
  });

  public sizeEnum = PdfSettingsSizeEnum;

  public  minHeight: number = 0;
  public  maxHeight: number = 256;
  public heightTypeList: {value: PdfSettingsSizeEnum; label: string}[] = [
    {value: PdfSettingsSizeEnum.NONE, label: '-'}, // 0
    {value: PdfSettingsSizeEnum.SMALL, label: 'PDF_SETTINGS.SMALL'}, // 16
    {value: PdfSettingsSizeEnum.MEDIUM, label: 'PDF_SETTINGS.MEDIUM'}, // 32
    {value: PdfSettingsSizeEnum.LARGE, label: 'PDF_SETTINGS.LARGE'}, // 64
    {value: PdfSettingsSizeEnum.USER_DEFINED, label: 'COMMON.USER_DEFINED'},
  ];

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor() {
    this.form.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.paddingUpdated.emit();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.hasOwnProperty('padding')) {
      // this.topEnabledControl.patchValue(get(this.padding, 'top.enabled'), {emitEvent: false});
      this.topSizeControl.patchValue(get(this.padding, 'top.size'), {emitEvent: false});
      this.topHeightControl.patchValue(get(this.padding, 'top.height'), {emitEvent: false});
      // this.bottomEnabledControl.patchValue(get(this.padding, 'bottom.enabled'), {emitEvent: false});
      this.bottomSizeControl.patchValue(get(this.padding, 'bottom.size'), {emitEvent: false});
      this.bottomHeightControl.patchValue(get(this.padding, 'bottom.height'), {emitEvent: false});
    }
  }

  public decreaseQuantity(control: FormControl): void {
    const value = control.value;
    if (value) {
      control.patchValue(value - 1);
    }
  }

  public increaseQuantity(control: FormControl): void {
    const value = control.value;
    if (!value) {
      control.patchValue(1);
    } else {
      control.patchValue(value + 1);
    }
  }

  public getUpdatedSettings(): PdfSettingsExtraPaddingModel {
    return {
      bottom: {
        ...this.bottomFormGroup.getRawValue(),
        height: this.getValidHeight(this.bottomHeightControl),
      },
      top: {
        ...this.topFormGroup.getRawValue(),
        height: this.getValidHeight(this.topHeightControl),
      }
    };
  }

  public getValidHeight(heightControl: FormControl): number {
    return (!heightControl.value || heightControl.value < this.minHeight)
      ? this.minHeight
      : (heightControl.value > this.maxHeight)
        ? this.maxHeight
        : heightControl.value;
  }

  get topFormGroup(): FormGroup { return this.form.get('top') as FormGroup; }
  get bottomFormGroup(): FormGroup { return this.form.get('bottom') as FormGroup; }

  // get topEnabledControl(): FormControl { return this.topFormGroup.get('enabled') as FormControl; }
  get topSizeControl(): FormControl { return this.topFormGroup.get('size') as FormControl; }
  get topHeightControl(): FormControl { return this.topFormGroup.get('height') as FormControl; }

  // get bottomEnabledControl(): FormControl { return this.bottomFormGroup.get('enabled') as FormControl; }
  get bottomSizeControl(): FormControl { return this.bottomFormGroup.get('size') as FormControl; }
  get bottomHeightControl(): FormControl { return this.bottomFormGroup.get('height') as FormControl; }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
